import {GeneratedDocumentList} from "./GeneratedDocumentList";
import {ProcessCard} from "./ProcessCard";
import {ProcessNames} from "../api/types";
import {Loader} from "@aws-amplify/ui-react";

export const GeneratePackingSlips = () => <ProcessCard title='Generate packing slips'
                                                       processName={ProcessNames.GENERATE_PACKING_SLIPS}
                                                       resultMessage="Your request to generate packing slips has been successfully initiated. The resulting file will be available for download within the next 2-5 minutes.">
  {(processStatus) => processStatus && processStatus?.isRunning === false ? <GeneratedDocumentList processName={ProcessNames.GENERATE_PACKING_SLIPS}/> : <Loader size='large' ariaLabel="Loading..."/>}
</ProcessCard>